import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { installiereDeutscheValidierung } from './utils/validierung';

// Umami Analytics — fest auf die selbst gehostete Instanz verdrahtet (data-domains verhindert Dev-Tracking)
const umamiUrl = 'https://umami.gsk-it.de';
const umamiWebsiteId = 'ecba0bd9-e1f9-4604-848a-01b83324d52c';
if (umamiUrl && umamiWebsiteId) {
  const script = document.createElement('script');
  script.defer = true;
  script.src = `${umamiUrl}/script.js`;
  script.dataset.websiteId = umamiWebsiteId;
  script.dataset.domains = 'app.heinze-pool.de';
  document.head.appendChild(script);
}

// Alle vorhandenen Service Worker deregistrieren
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((reg) => reg.unregister());
  });
}

// Hinweise der Formularprüfung auf Deutsch, unabhängig von der Browsersprache
installiereDeutscheValidierung();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
